import React from 'react';
import './NumberTaxiForRentPage.css';
import { Helmet } from 'react-helmet';
import NumberTaxiForRentTable from '../../components/NumberTaxiTables/NumberTaxiForRentTable';
import Ads1200100 from "../../components/Ads1200100/Ads1200100";
import AdsMoshezion from '../../components/Ads/AdsMoshezion/AdsMoshezion';
import NewTaxisHomePageCards from "../../components/NewTaxisHomePageCards/NewTaxisHomePageCards";
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";
import { FaWhatsapp } from "react-icons/fa"

const NumberTaxiForRentPage = () => {
  return (
    <>
<Helmet>
  {/* Title & Description */}
  <title>השכרת זכות ציבוריות למוניות | BuyTaxi - תשכיר ותרוויח</title>
  <meta name="description" content="מחפש להשכיר זכות ציבורית או מספר מונית? BuyTaxi הוא הבית שלך! פרסום חינמי, חשיפה מיידית, והזדמנות למצוא שוכרים אמיתיים במהירות. הצטרף ללוח ההשכרה המוביל בישראל." />

  {/* Open Graph Meta Tags */}
  <meta property="og:title" content="השכרת זכויות ציבוריות למוניות | פרסם חינם ב-BuyTaxi" />
  <meta property="og:description" content="לוח ההשכרה הכי חם בארץ! השכר את הזכות הציבורית שלך דרך BuyTaxi - פרסום חינם, לידים איכותיים, חשיפה רחבה." />
  <meta property="og:image" content="https://buytaxi.co.il/images/og-rent.jpg" />
  <meta property="og:url" content="https://buytaxi.co.il/NumberTaxiForRent" />
  <meta property="og:type" content="website" />

  {/* Twitter Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="השכר זכות ציבורית עכשיו | BuyTaxi" />
  <meta name="twitter:description" content="לוח זכויות ציבוריות להשכרה - פרסום קל, מהיר וחינמי. קבל פניות רציניות משוכרים אמיתיים." />
  <meta name="twitter:image" content="https://buytaxi.co.il/images/og-rent.jpg" />
  <meta name="twitter:site" content="@buytaxi" />

  {/* SEO Keywords */}
  <meta name="keywords" content="השכרת זכות ציבורית, זכויות ציבוריות להשכרה, מספר מונית להשכרה, מספר ציבורי להשכרה, לוח זכויות ציבוריות, השכרה מונית, השכרת מונית, תיווך מוניות, ליסינג מוניות, מספר צהוב, רישיון מונית להשכרה, השכרת רישיון מונית, לוח מוניות להשכרה, לוח מספרים ציבוריים, זכויות ציבוריות זמינות, נהג מונית להשכרה, מספר להשכרה מיידית, תחנות מוניות, נהג עצמאי, BuyTaxi, קנה טקסי, לוח השכרות מוניות, מונית להשכרה, מוניות פנויות להשכרה, הזדמנויות השכרה לנהגים, מוניות זמינות" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://buytaxi.co.il/NumberTaxiForRent" />
</Helmet>


      <div className='NumberTaxiForSellPageContiner'>
        <div className='BigAds'>
          <Ads1200100 />
        </div>
        <div className='NumberTaxiForSellPage-table'>
  <div className="NumberTaxiForSellPage-table-section">
    <NumberTaxiForRentTable />
  </div>
  <div className="NumberTaxiForSellPage-banner-section">
    <AdsMoshezion />
  </div>
</div>
<div className='FreePublishSendWhatsappNumberForRent'>
  <a
    href="https://wa.me/972502268395?text=היי%20מעוניין%20לפרסם%20זכות%20ציבורית%20באתר%20קנה%20טקסי"
    target="_blank"
    rel="noopener noreferrer"
    className="FreePublishSendWhatsappNumberForRent-link"
  >
    <div className="FreePublishSendWhatsappNumberForRent-header">
      <h2 className='FreePublishSendWhatsappNumberForRenth2'>פרסם בחינם</h2>
      <div className="FreePublishSendWhatsappNumberForRent-button">
        <FaWhatsapp className="whatsapp-icon" />
      </div>
    </div>
    <p className="FreePublishSendWhatsappNumberForRent-subtext">
      שלחו את הפרטים בוואטספ והופ זה באוויר
    </p>
  </a>
</div>


<div className='NumberTaxiForSellPage-NewTaxisHomePageCards'>
  <NewTaxisHomePageCards />
  </div>
  <div className="ArticlesPreviewNumberTaxiForRentPage">
  <ArticlesPreview />
</div>

      </div>
      </>
  );
};

export default NumberTaxiForRentPage;
